import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/*
 * O tailwind-merge só sabe desfazer conflito entre classes cuja escala ele conhece, e
 * ele conhece a escala *padrão* do Tailwind — não a nossa. Sem declarar os tokens aqui,
 * `text-body` (tamanho) cai no grupo de cor, porque `text-` serve para os dois e o
 * desconhecido vira cor. Aí ele apaga `text-white` e o botão primário renderiza o texto
 * herdado (escuro) sobre o fundo índigo — contraste reprovado.
 *
 * Espaçamento não entra aqui porque usa a escala nativa do Tailwind, que o
 * tailwind-merge já conhece. As listas são espelhadas de `tokens.css` e travadas por
 * teste.
 */
export const TEXT_SIZES = [
  'micro',
  'caption',
  'meta',
  'small',
  'control',
  'body',
  'body-lg',
  'lead',
  'title-sm',
  'title',
  'heading',
  'display',
  'display-lg',
] as const;

export const RADII = ['chip', 'control-sm', 'control', 'block', 'card', 'dialog', 'pill'] as const;

export const SHADOWS = [
  'card',
  'card-hover',
  'raised',
  'popover',
  'dialog',
  'sheet',
  'drawer',
  'bottom-nav',
  'toast',
  'process',
  'cta',
] as const;

const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: [...TEXT_SIZES],
      radius: [...RADII],
      shadow: [...SHADOWS],
    },
  },
});

/**
 * Junta classes condicionais e resolve conflitos de utilitário Tailwind — a última
 * classe vence. É o que permite a um componente aceitar `className` do chamador sem
 * que `p-5` do padrão e `p-2` de quem usa acabem os dois no HTML.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
